import React, { useEffect, useState } from "react";
import { reApi, errMsg, rePref, INTAKE_LABEL, INTAKE_TONE } from "@/lib/residentApi";
import { inputCls, Pill, Empty, ErrorLine } from "./ui";
import { ArchiveViewChips, countViews, inView, normView } from "@/components/nds/ArchiveView";
import { OpenResidentButton } from "@/components/nds/OpenResidentButton";

/** Scoped resident list (SA: all, case manager: assigned) with intake chips; persists the selection under tea_resident_*. */
export function ResidentPicker({ prefKey, filterIntake = false, onPick, testid, extra }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  const [q, setQ] = useState("");
  const [intake, setIntake] = useState(() => rePref.get(`${prefKey}_intake`, "all"));
  const [view, setViewRaw] = useState(() => normView(rePref.get(`${prefKey}_view`, "active")));
  const setView = (v) => { rePref.set(`${prefKey}_view`, v); setViewRaw(v); };
  useEffect(() => { reApi.get("/residents", { status: "all" }).then((d) => setRows(d.residents)).catch((e) => setError(errMsg(e))); }, []);
  const setI = (v) => { rePref.set(`${prefKey}_intake`, v); setIntake(v); };
  const list = (rows || []).filter((r) => inView(r, view) && (intake === "all" || (r.intake_status || "not_started") === intake)
    && `${r.first_name} ${r.last_name}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid={testid} className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search residents" data-testid={`${testid}-search`} className={`${inputCls} !w-56`} />
        <ArchiveViewChips prefix={`${testid}-view`} view={view} setView={setView} counts={countViews(rows || [])} size="sm" />
        {filterIntake && ["all", "not_started", "in_progress", "complete"].map((k) => (
          <button key={k} type="button" onClick={() => setI(k)} data-testid={`${testid}-filter-${k}`} aria-pressed={intake === k}
            className={`px-2.5 py-1 rounded-full border font-mono text-[9px] tracking-[0.16em] uppercase transition-colors ${intake === k ? "border-nex-gold text-nex-gold bg-nex-gold/10" : "border-white/10 text-nex-muted hover:text-nex-silver"}`}>{k === "all" ? "All" : INTAKE_LABEL[k]}</button>
        ))}
        {extra}
      </div>
      <ErrorLine testId={`${testid}-error`}>{error}</ErrorLine>
      {rows && !list.length ? <Empty testId={`${testid}-empty`}>No residents match.</Empty> : (
        <ul className="divide-y divide-white/5 border border-white/5 rounded-sm">
          {list.map((r) => (
            <li key={r.id}><button type="button" onClick={() => onPick(r)} data-testid={`${testid}-row-${r.id}`} className="w-full px-3 py-2 flex items-center gap-3 text-left text-sm hover:bg-nex-gold/5 transition-colors">
              <span className="text-nex-silver flex-1 truncate">{r.first_name} {r.last_name}</span>
              <OpenResidentButton residentId={r.id} name={`${r.first_name} ${r.last_name}`} testid={`open-resident-${testid}-${r.id}`} />
              {r.status === "archived" && <Pill tone="yellow" data-testid={`${testid}-archived-${r.id}`}>Archived</Pill>}
              <Pill tone="dim">Phase {r.current_phase}</Pill>
              <Pill tone={INTAKE_TONE[r.intake_status || "not_started"]} data-testid={`${testid}-intake-${r.id}`}>{INTAKE_LABEL[r.intake_status || "not_started"]}</Pill>
            </button></li>
          ))}
        </ul>
      )}
    </div>
  );
}
